import { LazyLoadImage } from "react-lazy-load-image-component";
import React from "react";
import { Row, Col } from "antd";
import HomeContectUs from "../../components/Home/HomeContectUs";
import "../../styles/about.css";
import { VisionMission } from "../../components/AboutUs/VisionMission";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Sandseekers - Your Trusted UAE Real Estate Partner</title>
        <meta
          name="description"
          content={
            "Learn about Sandseekers' journey in UAE real estate. Expert team, proven track record, and commitment to finding your perfect property in Dubai & Abu Dhabi."
          }
        />
        <link rel="canonical" href="https://www.sandseekers.ae/about-us" />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="About Sandseekers - Your Trusted UAE Real Estate Partner"
        />
        <meta
          property="og:description"
          content="Learn about Sandseekers' journey in UAE real estate. Expert team and proven track record in Dubai & Abu Dhabi properties."
        />
        <meta property="og:url" content="https://www.sandseekers.ae/about-us" />
        <meta property="og:site_name" content="Sandseekers" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Sandseekers - Your Trusted UAE Real Estate Partner"
        />
        <meta
          name="twitter:description"
          content="Expert real estate team with proven track record in Dubai & Abu Dhabi properties."
        />
      </Helmet>
      <Header />
      <Row>
        <Col xs={24} className="Container-top">
          <LazyLoadImage
            src="/icons/about.webp"
            alt="About Us"
            effect="blur"
            className="Container-top-image"
          />
          <div className="Container-content">
            <span className="heading-aboutUs">
              <FormattedMessage id="about_us" />
            </span>
            <span className="sub-heading">
              <FormattedMessage id="about_us_welcome" />
            </span>
          </div>
        </Col>
      </Row>
      <VisionMission
        imageClass="first-image"
        contentClass="second-image"
        heading={<FormattedMessage id="our_vision" />}
        text={<FormattedMessage id="vision_text" />}
        headingClass="heading-text"
        textClass="Div-text"
      />
      <VisionMission
        imageClass="first-image1"
        contentClass="second-image2"
        heading={<FormattedMessage id="our_mission" />}
        text={<FormattedMessage id="mission_text" />}
        headingClass="heading-text1"
        textClass="Div-text1"
      />
      <HomeContectUs />
    </>
  );
};

export default AboutUs;
